export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-background-100 py-12 md:py-16 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="relative z-10 w-full max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <div className="flex items-center gap-2 text-foreground-950 font-bold text-lg">
            <img
              alt="Cappy and Barry Adventures"
              className="w-8 h-8 object-contain"
              src="../../../../images/0ceb999f35a931c1da96a7ccbbd5c92f.png"
            />
            <span>Cappy &amp; Barry Adventures</span>
          </div>
          <p className="text-sm text-foreground-500">
            Fun-filled stories for little hearts
          </p>
        </div>

        <div className="border-t border-background-200 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              <button
                onClick={() => scrollTo("#characters")}
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                The Characters
              </button>
              <button
                onClick={() => scrollTo("#books")}
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                The Books
              </button>
              <button
                onClick={() => scrollTo("#reviews")}
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                Reviews
              </button>
              <button
                onClick={() => scrollTo("#about")}
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                About Author
              </button>
              <button
                onClick={() => scrollTo("#contact")}
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                Contact
              </button>
              <a
                href="https://cappybarry.gumroad.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                Gumroad Store
              </a>
            </div>
            <div className="text-right">
              <p className="text-sm text-foreground-400">
                Created by Annmarie Mare
              </p>
              <p className="text-sm text-foreground-400 mt-1">
                &copy; 2026 Kevin Nagel. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}